module.exports = __webpack_public_path__ + "img/trading212-dark.519d33e2.png";